

import axios, { AxiosResponse } from "axios";
import { SupportDepartmentTitleValueDTO } from "../../models/dtos/supporter/SupportDepartmentTitleValueDTO";
import BaseService from "../base/BaseService";

export default class SupportDepartmentService extends BaseService {
    getTitleValue(): Promise<SupportDepartmentTitleValueDTO[]> {
        return axios.get( `/Students/TicketHandlerUserIds`)
            .then(function (response: AxiosResponse<SupportDepartmentTitleValueDTO[]>) {
                return response.data;
            });
    }
}